import React from 'react';

import { useNavigation } from '@react-navigation/native';

import { Bet } from '../hooks/types';
import { getSettledEntryStatus } from '../utils/get-settled-entry-status';
import { SbkOpenEntryCard } from './bet-cards/SbkOpenEntryCard';
import { SbkSettledEntryCard } from './bet-cards/SbkSettledEntryCard';

type SbkBetCardProps = {
    bet: Bet;
};

export const SbkBetCard = ({ bet }: SbkBetCardProps) => {
    const navigation = useNavigation();
    const onPress = () => navigation.navigate('SbkBetScreen', { betId: bet.id, bet });
    const onSharePress = () => navigation.navigate('BetShareScreen', { betId: bet.id, bet });

    if (bet.result === 'PENDING') {
        return <SbkOpenEntryCard bet={bet} onPress={onPress} onSharePress={onSharePress} />;
    }

    // Every settled Result maps to a status; an unrecognised value renders nothing.
    const settledStatus = getSettledEntryStatus(bet.result);
    if (!settledStatus) {
        return null;
    }

    return <SbkSettledEntryCard bet={bet} status={settledStatus} onPress={onPress} onSharePress={onSharePress} />;
};
